import Typography from "@mui/material/Typography";
import Box from "@mui/system/Box";
import { useContent } from "../app/ContentContext";
import PageHeader from "../components/PageHeader";

function HearingAid() {
  const { hearingAidSuppliers, hearingAidPage } = useContent();
  return (
    <Box sx={{ pb: 5 }}>
      <PageHeader title={hearingAidPage.title} />
      <Box sx={{ maxWidth: "560px", mx: "auto", px: 2 }}>
        {hearingAidPage.paragraphs.map((paragraph, index) => (
          <Typography
            key={index}
            variant="h6"
            color="text.secondary"
            sx={{
              mb:
                index < hearingAidPage.paragraphs.length - 1 ? 2 : 4,
              lineHeight: 1.7,
            }}
          >
            {paragraph}
          </Typography>
        ))}

        <Box
          sx={{
            textAlign: "center",
            backgroundColor: "common.white",
            borderRadius: 3,
            boxShadow: "0 2px 16px rgba(7, 73, 116, 0.08)",
            p: 3,
          }}
        >
          <Typography
            gutterBottom
            sx={{
              fontSize: "1.2rem",
              fontWeight: 600,
              mb: 2,
              color: "secondary.main",
            }}
          >
            {hearingAidPage.supplierIntro}
          </Typography>

          {hearingAidSuppliers.map((supplier, index) => (
            <Typography
              key={index}
              variant="body1"
              color="text.secondary"
              sx={{ mt: index === 0 ? 0 : 0.5 }}
            >
              {supplier.name} -{" "}
              <a href={`tel:${supplier.phone}`} style={{ color: "inherit" }}>
                {supplier.phone}
              </a>
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default HearingAid;
